<div class="header">
    <p>Seguridad</p>
  </div>
  <div class="body text-center">

    <div class="message fw-sbold m-0 mb-3 p-0">Escribe tu contraseña para poder continuar</div>
  
    <form [formGroup]="passForm" >
        <label class="mnf-control form-password my-3 w-75 m-auto d-block">
            <input class="mnf-input-form pass" [type]="passwordFlag" placeholder="•••••••••" id="password" formControlName="password">
            <i class="mnf-show cr-pointer fs-17" *ngIf="passwordFlag === 'password'" (click)="passwordFlag = 'text'"style="top: 30%"></i>
            <i class="mnf-hide cr-pointer fs-19" *ngIf="passwordFlag === 'text'" (click)="passwordFlag = 'password'" style="top: 28%"></i>
        </label>
    
        <div class="d-flex justify-content-evenly mb-2 mt-4">
          <button mat-button class="invert" type="button" (click)="cancel()">Cancelar</button>
          <button mat-button type="button" class="" (click)="accept()">Aceptar</button>
        </div>
    </form>
  
  </div>
  